"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.createUrlSearchParams = exports.buildUrl = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var createUrlSearchParams = function createUrlSearchParams(query) {
  if (query === void 0) {
    query = {};
  }
  var queryParams = [];
  var keys = Object.keys(query);
  for (var i = 0, l = keys.length; i < l; i += 1) {
    queryParams.push(keys[i] + "=" + query[keys[i]]);
  }
  return queryParams.join('&');
};
exports.createUrlSearchParams = createUrlSearchParams;
var buildUrl = function buildUrl(options) {
  if ((0, _typeof2.default)(options) === 'object') {
    var pathname = options.pathname,
      query = options.query;
    var url = pathname;
    if ((0, _typeof2.default)(query) === 'object') {
      url += "?" + createUrlSearchParams(query);
    }
    return url;
  }
  return options;
};
exports.buildUrl = buildUrl;